import React from "react";

import store from "app/store";
import { MainView, Modal, Form, FormMessage, Button } from "lib/components/index";
import * as FormControl from "lib/components/FormControl";
import st from "lib/utils/index";
import { ProductsRepository } from "lib/repositories/index";
import "./NewProductPrompt.css";

class NewProductPrompt extends React.PureComponent {
  state = {
    product: {
      product_type: "accommodation",
      booking_type: "static_date_range_booking",
      name: "",
    },
    valid: false,
    submitLoading: false,
    error: null,
  };
  subscriptions = [];

  componentWillUnmount() {
    this.subscriptions.forEach((s) => s.unsubscribe());
    this.subscriptions.length = 0;
  }

  handleProductPropsChange(props) {
    const { product } = this.state;
    const nextProduct = { ...product, ...props };
    this.setState({
      product: nextProduct,
      valid: !!nextProduct.name,
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { company, resolve } = this.props;
    const { product, valid, submitLoading } = this.state;
    if (!valid || submitLoading) {
      return;
    }
    const isHotel = company.biz_type === "hotel";
    const isAccommodation = product.product_type === "accommodation";

    this.setState({ submitLoading: true, error: null });
    const create$ = ProductsRepository.create({
      company_id: company.id,
      product_type: product.product_type,
      booking_type: product.booking_type,
      status: "draft",
      enable_frontend_slots_listing: false,
      translations: [
        {
          locale: I18n.locale,
          name: product.name,
        },
      ],
      ...(isHotel && isAccommodation && company.location_lat && company.location_lng
        ? {
            product_locations: [
              {
                location_lat: company.location_lat,
                location_lng: company.location_lng,
                position: 1,
                translations: [
                  {
                    id: I18n.locale,
                    locale: I18n.locale,
                    location_name: company.location_name,
                  },
                ],
              },
            ],
          }
        : {}),
      product_variants: [
        {
          translations: [
            {
              locale: I18n.locale,
            },
          ],
          ...(isAccommodation
            ? {
                default_total_stock_limit: 1,
                accommodation_detail: {
                  category: "two_person_room",
                  single_beds_count: 0,
                  double_beds_count: 0,
                  extra_beds_count: 0,
                  rooms_count: 1,
                  bathrooms_count: 0,
                  area: null,
                },
              }
            : {}),
        },
      ],
    }).subscribe(
      (product) => {
        this.setState({ submitLoading: false });
        resolve(product);
      },
      (error) => {
        st.api.handleError(error, store);
        this.setState({ submitLoading: false, error: st.api.findResponseErrorMessage(error) });
      }
    );
    this.subscriptions.push(create$);
  }

  handleTypeChange(type) {
    switch (type) {
      case "standard":
        this.handleProductPropsChange({ product_type: "standard", booking_type: "static_date_booking" });
        break;
      case "coupon":
        this.handleProductPropsChange({ product_type: "coupon", booking_type: "no_booking" });
        break;
      case "voucher":
        this.handleProductPropsChange({ product_type: "voucher", booking_type: "no_booking" });
        break;
      case "ticket":
        this.handleProductPropsChange({ product_type: "ticket", booking_type: "no_booking" });
        break;
      case "accommodation":
        this.handleProductPropsChange({ product_type: "accommodation", booking_type: "static_date_range_booking" });
        break;
    }
  }

  render() {
    const { modalRef, resolve, company, ...props } = this.props;
    const { product, valid, submitLoading, error } = this.state;
    const assignationTypeOptions = [
      [
        "accommodation",
        <strong>{I18n.t("papp.products.NewProductPrompt.offer_type_accommodation_header")}</strong>,
        [
          <p key="voucher">
            <small>{I18n.t("papp.products.NewProductPrompt.offer_type_accommodation_description")}</small>
            <br />
          </p>,
        ],
      ],
      [
        "standard",
        <strong>{I18n.t("papp.products.NewProductPrompt.offer_type_standard_header")}</strong>,
        [
          <p key="st">
            <small>{I18n.t("papp.products.NewProductPrompt.offer_type_standard_description")}</small>
            <br />
          </p>,
        ],
      ],
      [
        "voucher",
        <strong>{I18n.t("papp.products.NewProductPrompt.offer_type_voucher_header")}</strong>,
        [
          <p key="voucher">
            <small>{I18n.t("papp.products.NewProductPrompt.offer_type_voucher_description")}</small>
            <br />
          </p>,
        ],
      ],
      [
        "ticket",
        <strong>{I18n.t("papp.products.NewProductPrompt.offer_type_ticket_header")}</strong>,
        [
          <p key="ticket">
            <small>{I18n.t("papp.products.NewProductPrompt.offer_type_ticket_description")}</small>
            <br />
          </p>,
        ],
      ],
      [
        "coupon",
        <strong>{I18n.t("papp.products.NewProductPrompt.offer_type_coupon_header")}</strong>,
        [
          <p key="coupon">
            <small>{I18n.t("papp.products.NewProductPrompt.offer_type_coupon_description")}</small>
            <br />
          </p>,
        ],
      ],
    ];

    return (
      <Modal closeIcon closeOnDimmerClick={false} size="small" ref={modalRef} {...props}>
        <Modal.Header>{I18n.t("papp.products.NewProductPrompt.title")}</Modal.Header>
        <Modal.Content>
          <Form onSubmit={this.handleSubmit.bind(this)} loading={submitLoading} error={!!error}>
            <FormMessage error={error} />

            <FormControl.InputFormGroup
              value={product.name}
              onChange={(name) => this.handleProductPropsChange({ name })}
              label={I18n.t("papp.products.NewProductPrompt.name_placeholder")}
              required
              autoFocus
            />

            {/* <FormControl.CheckboxFormGroup
              checked={product.product_type === "coupon"}
              onChange={checked => this.handleProductPropsChange(checked ? { product_type: "coupon", booking_type: "no_booking" } : { product_type: "standard", booking_type: "static_date_booking" })}
              label={I18n.t("papp.products.NewProductPrompt.coupon_label")}

            /> */}
            <div className="npp">
              <FormControl.MultipleRadioFormGroup
                onChange={this.handleTypeChange.bind(this)}
                label={I18n.t("papp.products.NewProductPrompt.offer_type_header")}
                options={assignationTypeOptions}
                withDescription
                required
                value={product.product_type}
              />
            </div>

            <button type="submit" hidden disabled={!valid || submitLoading} />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button as="a" disabled={submitLoading} onClick={() => resolve()} content={I18n.t("papp.common.cancel")} />
          <Button
            as="a"
            primary
            floated="right"
            disabled={!valid || submitLoading}
            onClick={this.handleSubmit.bind(this)}
            content={I18n.t("papp.products.NewProductPrompt.submit")}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

export default function openNewProductPrompt(props) {
  return st.createModal(NewProductPrompt, props);
}



// WEBPACK FOOTER //
// ./src/modules/products/NewProductPrompt/NewProductPrompt.jsx